import packageJson from '../../package.json';

export const getConfig = () => {
  // Use environment variables directly - they are set at build time
  // In local dev: VITE_API_HOST from .env.development
  // In production build: VITE_API_HOST from .env.production
  
  const hostname = window.location.hostname;
  const isLocalDev = hostname.includes('localhost') || hostname.includes('127.0.0.1');
  
  // Default API hosts based on environment
  const defaultApiHost = isLocalDev ? 'uptime.dev.shzoom.com' : 'uptime.shzoom.com';
  
  // Use the environment variable if set, otherwise use default
  const apiHost = import.meta.env.VITE_API_HOST || defaultApiHost;
  
  return {
    apiHost: apiHost,
    apiBaseUrl: `https://${apiHost}/api`,
    tenant: 'uptime',
    appVersion: packageJson.version,
    environment: import.meta.env.MODE || 'production'
  };
};

export const config = getConfig();

export default config;